import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { IAffiliateProgramCreativesActivatePayload } from '../types';
import {
  AFFILIATE_PROGRAM_CREATIVES_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS,
  AFFILIATE_PROGRAM_DEACTIVATE_CREATIVE_API_URL,
  AFFILIATE_PROGRAM_DEACTIVATE_CREATIVE_MUTATION_KEY,
} from '../constants';

export default function useDeactivateCreativeMutation(): IContextMutationResult<
  void,
  Error,
  IAffiliateProgramCreativesActivatePayload
> {
  const { fetchPost } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, IAffiliateProgramCreativesActivatePayload>({
    mutationKey: [AFFILIATE_PROGRAM_DEACTIVATE_CREATIVE_MUTATION_KEY],
    mutationFn: (payload) => fetchPost<void>(
      AFFILIATE_PROGRAM_DEACTIVATE_CREATIVE_API_URL,
      payload,
      { permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.ACTIVATE },
    ),
    onSuccess({ queryClient }) {
      void queryClient.invalidateQueries({ queryKey: [AFFILIATE_PROGRAM_CREATIVES_LIST_QUERY_KEY] });
      displayPresetToast('success');
    },
  });
}
